import { render } from "./Programmer.vue?vue&type=template&id=38036c53&scoped=true"
import script from "./Programmer.vue?vue&type=script&lang=js"
export * from "./Programmer.vue?vue&type=script&lang=js"

import "./Programmer.vue?vue&type=style&index=0&id=38036c53&scoped=true&lang=css"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38036c53"]])

export default __exports__